module.exports = __webpack_public_path__ + "static/media/unbound3.1661b42c.png";